<template>
  <section class="container">
    <slot></slot>
  </section>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    prop: {
      type: String,
      required: false
    }
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    // type your function
  },
  created() {},
  mounted() {},
  updated() {},
  destroyed() {},
  filters: {}
}
</script>

<style scoped lang="less">
@import '../../common/Less/index';

.container {
  width: @pcWidth;
  border-bottom: 1px solid @borderColor;
  margin: 49px auto 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue